import { useState } from "react";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useCreateTask() {
  const { api, AdminId, setApiCall } = useGlobalContext();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const shouldShowLocalError = (data) => {
    return (
      data?.responseCode !== "00" &&
      data?.responseCode !== "02" &&
      data?.responseCode !== "03" &&
      data?.responseCode !== "98" &&
      data?.responseCode !== "401"
    );
  };

  const createTask = async (formData, deliveryItems, taskImages) => {
    setIsSubmitting(true);

    const payload = {
      ...formData,
      deliveryLatitude: "",
      deliveryLongitude: "",
      pickupLatitude: "",
      pickupLongitude: "",
      taskImages: taskImages,
      adminId: AdminId,
      deliveryDetails: {
        items: deliveryItems.filter((item) =>
          Object.values(item).some((val) => String(val || "").trim() !== "")
        ),
      },
    };

    try {
      const response = await api.post("/api/Task/v2.0/createTask", payload);

      if (response.data?.responseCode === "00") {
        toast.success(response.data?.responseMessage || "Task created");
        setApiCall(true);
        return true;
      }

      if (shouldShowLocalError(response.data)) {
        toast.error(response.data?.responseMessage || "Failed to create task");
      }

      return false;
    } catch (error) {
      console.error("createTask error:", error);
      toast.error("Error adding the task");
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    createTask,
    isSubmitting,
  };
}